(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["kenjo-story"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('kenjo-story')){
    customElements.define('kenjo-story',class extends HTMLElement{
      connectedCallback(){
        if(this._init)return;
        this._init=true;this.video=this.querySelector('video');this.toggle=this.querySelector('[data-story-toggle]');
        if(!this.video||!this.toggle)return;
        this.video.muted=true;this.userPaused=false;this.inView=false;
        this.motion=window.matchMedia('(prefers-reduced-motion: reduce)');
        this.auto=this.dataset.autoplay==='true'&&!this.motion.matches&&!(navigator.connection&&navigator.connection.saveData);
        this.clickHandler=()=>{if(this.video.paused){this.userPaused=false;this.start()}else{this.userPaused=true;this.video.pause()}};
        this.stateHandler=()=>this.updateButton();
        this.readyHandler=()=>this.classList.add('kenjo-story--video-ready');
        this.errorHandler=()=>{this.classList.remove('kenjo-story--video-ready');this.toggle.hidden=true};
        this.visibilityHandler=()=>{if(document.hidden){this.video.pause()}else if(this.inView&&this.auto&&!this.userPaused){this.start()}};
        this.motionHandler=()=>{if(this.motion.matches){this.auto=false;this.video.pause()}};
        this.toggle.addEventListener('click',this.clickHandler);
        this.video.addEventListener('play',this.stateHandler);this.video.addEventListener('pause',this.stateHandler);
        this.video.addEventListener('loadeddata',this.readyHandler);this.video.addEventListener('error',this.errorHandler);
        document.addEventListener('visibilitychange',this.visibilityHandler);
        this.motion.addEventListener('change',this.motionHandler);
        if('IntersectionObserver' in window){
          this.observer=new IntersectionObserver(entries=>{for(const entry of entries){this.inView=entry.isIntersecting;if(this.inView&&this.auto&&!this.userPaused&&!document.hidden){this.start()}else if(!this.inView){this.video.pause()}}},{rootMargin:'120px 0px',threshold:.05});
          this.observer.observe(this);
        }
        this.updateButton();
      }
      load(){
        if(this.loaded)return;
        const template=this.video.querySelector('template[data-story-source]');
        if(!template)return;
        this.video.append(template.content.cloneNode(true));this.video.load();this.loaded=true;
      }
      start(){this.load();const promise=this.video.play();if(promise)promise.catch(()=>this.updateButton())}
      updateButton(){const playing=!this.video.paused;const label=playing?this.dataset.pauseLabel:this.dataset.playLabel;this.toggle.dataset.state=playing?'playing':'paused';this.toggle.setAttribute('aria-label',label);this.toggle.querySelector('[data-story-label]').textContent=label}
      disconnectedCallback(){
        if(!this.video||!this.toggle)return;
        if(this.observer)this.observer.disconnect();
        this.video.pause();
        this.toggle.removeEventListener('click',this.clickHandler);
        this.video.removeEventListener('play',this.stateHandler);this.video.removeEventListener('pause',this.stateHandler);
        this.video.removeEventListener('loadeddata',this.readyHandler);this.video.removeEventListener('error',this.errorHandler);
        document.removeEventListener('visibilitychange',this.visibilityHandler);this.motion.removeEventListener('change',this.motionHandler);
        this._init=false;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
